import React, { Component } from "react";

import "./styles.css";

export default class AccountInfoCard extends Component {

  render() {
    const account = this.props.account;
    return (
      <div className="card-body">
        <a className="regular-text" >Number: {account.account_number}</a>
        <a className="regular-text" >Cash: ${account.cash}</a>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/LiveTradingView/components/AccountInfoCard.js